import { useOktaAuth } from "@okta/okta-react";
import React, { useState, useEffect } from "react";
import cx from "classnames";
import { RCL, RCL as useTranslation } from "../../components/RCL";
import { Row, Cell, Modal } from "@sunwing/components";
import { Button as ButtonComponent } from "@sunwing/components/dist/Button";
import { Img } from "@sunwing/shared-components";
import { Loader } from "../../components/Loader";
import config from "../../app/config";
import styles from "./StarCardModal.module.scss";
import marked from "marked";
import parse from "html-react-parser";

const formatDateOfBirth = (value) => {
  const digits = value.replace(/\D/g, "").slice(0, 8);
  if (digits.length >= 4) {
    return `${digits.slice(0, 2)}-${digits.slice(2, 4)}-${digits.slice(4)}`;
  }
  if (digits.length >= 2) {
    return `${digits.slice(0, 2)}-${digits.slice(2)}`;
  }
  return digits;
};

const StarCardModal = ({
  isOpen,
  setIsOpen,
  redeemAmount,
  redeemPoints,
  provinceList,
  starCardData,
  closeSuccessMessage,
  locale,
}) => {
  const { oktaAuth } = useOktaAuth();
  const [phoneNumber, setPhoneNumber] = useState(starCardData.cContactPhone || "" );
  const [fax, setFax] = useState(starCardData.cFax || "");
  const [city, setCity] = useState("");
  const [province, setProvince] = useState("");
  const [address, setAddress] = useState("");
  const [postalcode, setPostalcode] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [shippingMethod, setShippingMethod] = useState("1");
  const [isModalOpen, setIsModalOpen] = useState(isOpen);
  const [validation, setValidation] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [serverMessage, setServerMessage] = useState("");
  const [isValidPhone, setIsValidPhone] = useState(null);
  const [isValidAddress, setIsValidAddress] = useState(null);
  const [isValidCity, setIsValidCity] = useState(null);
  const [isValidProvince, setIsValidProvince] = useState(null);
  const [isValidPostal, setIsValidPostal] = useState(null);
  const [isValidShippingMethod, setIsValidShippingMethod] = useState(null);
  const [isValidDateOfBirth, setIsValidDateOfBirth] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [starContentData, setStarContentData] = useState(null);
  const [showAddress1Example, setShowAddress1Example] = useState(false);
  const shippingMethods = [
    { id: 1, shippingMethodCode: "1", shippingMethodName: "USPS International (7-21 business days)" },
    { id: 2, shippingMethodCode: "8", shippingMethodName: "UPS Worldwide Saver" },
    { id: 3, shippingMethodCode: "9", shippingMethodName: "UUPS Standard (day definite by date scheduled delivery by end of day)" },
  ];

  const getStarContentData = async () => {
    const starRegistrationQuery = `
      query starRegistration($contentfulId: String!, $locale: String!) {
        starContent(id: $contentfulId, locale: $locale) {
          sys {
            id
          }
          title
          content
          imageIfApplicable {
            url
            size
          }
        }
      }
      `;

    await fetch(config.resourceServer.contentfulApimAgentGqlUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${oktaAuth.getAccessToken()}`,
      },
      body: JSON.stringify({
        query: starRegistrationQuery,
        variables: { 
          contentfulId: "30V3aw57sksO2yCyaaeG0W", 
          locale: locale === "fr" ? locale : "en-CA", 
        },
      }),
    })
      .then((response) => response.json())
      .then(({ data, errors }) => {
        if (errors) {
          console.error(errors);
        }else{
        setStarContentData(data?.starContent);
        }
      });
  };

    useEffect(() => {
      getStarContentData();
    }, [locale]);

  const dictionary = {
    OK_StarRegistrationSuccessful: useTranslation({
      searchKey: "OK_StarRegistrationSuccessful",
    }),
    ERR_InvalidFirstName: useTranslation({
      searchKey: "ERR_InvalidFirstName",
    }),
    ERR_InvalidLastName: useTranslation({
      searchKey: "ERR_InvalidLastName",
    }),
    ERR_InvalidPhone: useTranslation({ searchKey: "ERR_InvalidPhone" }),
    ERR_InvalidAddress: useTranslation({
      searchKey: "ERR_InvalidAddress",
    }),
    ERR_InvalidCity: useTranslation({
      searchKey: "ERR_InvalidCity",
    }),
    ERR_InvalidEmail: useTranslation({ searchKey: "ERR_InvalidEmail" }),
    ERR_InvalidProvince: useTranslation({
      searchKey: "ERR_InvalidProvince",
    }),
    ERR_InvalidPostalCode: useTranslation({
      searchKey: "ERR_InvalidPostalCode",
    }),
    ERR_RequestNotCompleted: useTranslation({
      searchKey: "ERR_RequestNotCompleted",
    }),  
    Err_InvalidDateOfBirth: useTranslation({
      searchKey: "Err_InvalidDateOfBirth",
    }),
    OK_StarRegistrationLoadSuccessful: useTranslation({
      searchKey: "OK_StarRegistrationLoadSuccessful",
    }),
  };

  // Validation for Field function
  const validateField = (input, validation) => {
    let isValid = true;
    let isRequired = true;

    if (input.required === undefined) {
      if (input.value.toString().length === 0) {
        isRequired = false;
      }
    }

    if (isRequired) {
      switch (validation) {
        case "name":
          if (input.value.replace(/\s+/g, "").length < 1) {
            isValid = false;
          } else {
            isValid = /^[A-Za-zÀ-ú\s\-'’ ]*$/.test(input.value);
          }
          break;
        case "length":
          if (input.value.length < 1) {
            isValid = false;
          } else {
            isValid = true;
          }
          break;
        case "phone":
          isValid = /^(?!1)\d{10}$/.test(input.value);
          break;
        case "address":
          isValid = /^(?!.*[?@&!#~();+_$%-])[\x20-\x22\x24-\x3F\x41-\x7E\u00A1-\u00FF]{1,30}$/.test(input.value);
          break;
        case "dropdown":
          if (input.value.length < 1) {
            isValid = false;
          } else {
            isValid = true;
          }
          break;
        case "email":
          // eslint-disable-next-line no-useless-escape
          var emailRegex =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (input.value.length < 1) {
            isValid = false;
          } else {
            isValid = emailRegex.test(input.value);
          }
          break;
        case "postal":
          // Canadian Postal Code "Rules" - https://stackoverflow.com/questions/1146202/canadian-postal-code-validation
          // https://en.wikipedia.org/wiki/Postal_code#Reserved_characters
          var postalRegex =
            /[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ].?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]/i;
          if (input.value.replace(/\s/g, "").length !== 6) {
            isValid = false;
          } else {
            isValid = postalRegex.test(input.value);
          }
          break;
        case "date":
          // Validate dd-MM-yyyy format
          var dateRegex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-(\d{4})$/;
          if (!dateRegex.test(input.value)) {
            isValid = false;
          } else {
            // Additional validation: check if date is valid
            const parts = input.value.split('-');
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10);
            const year = parseInt(parts[2], 10);
            const date = new Date(year, month - 1, day);
            isValid = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
          }
          break;
        default:
          isValid = true;
      }
    }
    return isValid;
  };

  const onChangeInput = (event) => {
    setValue(event);
    handleValidation(event);

    const { id: field } = event.target;
    if(field === 'address'){
      setShowAddress1Example(false);
    }
  };

  const handleStarAddress1Focus = (event) => {
    setShowAddress1Example(true);
  }

  const handleDateOfBirthKeyDown = (event) => {
    const input = event.currentTarget;
    if (
      event.key !== "Backspace" ||
      input.selectionStart !== input.selectionEnd ||
      input.selectionStart === 0 ||
      input.value[input.selectionStart - 1] !== "-"
    ) {
      return;
    }

    event.preventDefault();
    const digitsBefore = input.value
      .slice(0, input.selectionStart - 1)
      .replace(/\D/g, "")
      .slice(0, -1);
    const digitsAfter = input.value.slice(input.selectionEnd).replace(/\D/g, "");
    const formattedDate = formatDateOfBirth(digitsBefore + digitsAfter);
    setDateOfBirth(formattedDate);
    const dateRegex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-(\d{4})$/;
    setIsValidDateOfBirth(dateRegex.test(formattedDate));
  };

  const setValue = (event) => {
    let input = event.target;
    if (input.id === "phoneNumber") setPhoneNumber(input.value);
    else if (input.id === "address") setAddress(input.value);
    else if (input.id === "city") setCity(input.value);
    else if (input.id === "fax") setFax(input.value);
    else if (input.id === "dateOfBirth") {
      const formattedDate = formatDateOfBirth(input.value);
      setDateOfBirth(formattedDate);
      const dateRegex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-(\d{4})$/;
      setIsValidDateOfBirth(dateRegex.test(formattedDate));
    } else if (input.id === "province") {
      setProvince(input.value);
      if (input.value !== "") setIsValidProvince(true);
      else setIsValidProvince(false);
    } else if (input.id === "postalCode") setPostalcode(input.value);
  }

  const handleValidation = (event) => {
    let input = event.target;
     let validationString = "";

    if (input.id === "phoneNumber") {
      setValidation("phone");
      validationString = "phone";
    }

    if (input.id === "city") {
      setValidation("length");
      validationString = "length";
    }

    if (input.id === "address") {
      setValidation("address");
      validationString = "address";
    }

    if (input.id === "province") {
      setValidation("dropdown");
      validationString = "dropdown";
    }

    if (input.id === "postalCode") {
      setValidation("postal");
      validationString = "postal";
    }

    if (input.id === "shippingMethod") {
      setValidation("dropdown");
      validationString = "dropdown";
    }

    if (input.id === "dateOfBirth") {
      setValidation("date");
      validationString = "date";
    }

    // Validate field
    if (input.getAttribute("required") !== null && input.value !== "") {
      if (
        input.id === "phoneNumber" ||
        input.id === "address" ||
        input.id === "city"
      ) {
        if (input.id === "phoneNumber") {
          setIsValidPhone(validateField(input, validationString));
          input.isValid = isValidPhone;
        }
        if (input.id === "address") {
          setIsValidAddress(validateField(input, validationString));
          input.isValid = isValidAddress;
        }
        if (input.id === "city") {
          setIsValidCity(validateField(input, validationString));
          input.isValid = isValidCity;
        }
        if (input.id === "dateOfBirth") {
            setIsValidDateOfBirth(validateField(input, validationString));
          input.isValid = isValidDateOfBirth;
        }
      }
      if (input.id === "province") {
        setIsValidProvince(validateField(input, validationString));
        input.isValid = isValidProvince;
      }
      if (input.id === "postalCode") {
        setIsValidPostal(validateField(input, validationString));
        input.isValid = isValidPostal;
      }
      if (input.id === "shippingMethod") {
        setIsValidShippingMethod(validateField(input, validationString));
        input.isValid = isValidShippingMethod;
      }
    }
  };

  const handleSubmit = (event) => {
    
    event.preventDefault();
      setSubmitting(true);
      setServerMessage("");

    // Recompute validation from current field values rather than trusting stale onBlur-driven state
    const validPhone = validateField({ value: phoneNumber, required: true }, "phone");
    const validAddress = validateField({ value: address, required: true }, "address");
    const validCity = validateField({ value: city, required: true }, "length");
    const validProvince = validateField({ value: province, required: true }, "dropdown");
    const validPostal = validateField({ value: postalcode, required: true }, "postal");
    const validDateOfBirth = validateField({ value: dateOfBirth, required: true }, "date");

    setIsValidPhone(validPhone);
    setIsValidAddress(validAddress);
    setIsValidCity(validCity);
    setIsValidProvince(validProvince);
    setIsValidPostal(validPostal);
    setIsValidDateOfBirth(validDateOfBirth);

    let validForm =
      validPhone &&
      validAddress &&
      validCity &&
      validProvince &&
      validPostal &&
      validDateOfBirth;

    if (validForm) {
      const [day, month, year] = dateOfBirth.split("-");
      const dateOfBirthForApi = `${year}-${month}-${day}`;
      var AgentInfo = {
        Agent: {
          cLoginEmail: starCardData?.cLoginEmail,
          cContactPhone: phoneNumber,
          cFax: fax,
          cAddress1: address,
          cCity: city,
          cProvince: province,
          cPostalCode: postalcode.trim(),
          ShippingMethod: shippingMethod,
          dDateOfBirth: dateOfBirthForApi,
          RedeemAmount: redeemAmount,
          RedeemPoints: redeemPoints,
        },
      };

      fetch(`${config.resourceServer.agentApiUrl}/loyalty`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${oktaAuth.getAccessToken()}`,
        },
        body: JSON.stringify(AgentInfo),
      })
      .then(async (response) => {
        const responseBody = await response.text();
        if (response.ok) {            
          setServerMessage(dictionary["OK_StarRegistrationLoadSuccessful"].replace("{0}",redeemPoints).replace("{1}", redeemAmount));
          setIsSuccess(true);
          setSubmitting(false);
        } else {
          let errorMessage = responseBody || response.statusText;
          try {
            errorMessage = JSON.parse(responseBody).description || errorMessage;
          } catch (error) {
            errorMessage = responseBody || response.statusText;
          }
          setServerMessage("error " + errorMessage);
          setSubmitting(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setServerMessage("error " + err.message);
        setSubmitting(false);
      });
    }
    else {
      setServerMessage(dictionary["ERR_RequestNotCompleted"]);
      setSubmitting(false);
    }
  };

  const handleClose = () => {  
    setIsSuccess(false);
    toggleModal(false);
    closeSuccessMessage();
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setIsOpen(!isOpen);   
  };

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={toggleModal}
      labels={{ close: "Close" }}
      simple={true}
      top={false}
    >
      {starCardData && <Loader />}
      {starContentData && (
        <Modal.Content className={styles.modal}>
          <p className={styles.modalTitle}>
            <RCL searchKey="becomeMember" />
          </p>
          <Row cols={2} className={styles.modalGrid}>
            <Cell>
              <div>{parse(marked(starContentData.content))}</div>
            </Cell>
            <Cell>
              <Img
                src={starContentData.imageIfApplicable.url}
                alt="Star Card"
              />
            </Cell>
          </Row>         
          <form action="">           
            {serverMessage !== null && serverMessage.length > 0 && (
              <div className={cx(isSuccess?styles.successful:styles.error)}>{serverMessage}</div>
            )}
            {submitting && <Loader/>}
            {!isSuccess && (
            <div>
            <Row
              cols={2}
              className={cx(styles.modalGrid, styles.modalGridNames)}
            >
              <Cell>
                <label name="firstName">                
                  <RCL searchKey="firstName" />                                                 
                </label>               
                <input
                  type="text"
                  id="FirstName"
                  required={true}
                  readOnly={true}
                  maxLength="50"
                  value={starCardData?.cFirstName}
                  onBlur={(event) => onChangeInput(event)}
                />
              </Cell>
              <Cell>
                <label name="lastName">                
                  <RCL searchKey="lastName" />                
                </label>
                <input
                  type="text"
                  id="lastName"
                  readOnly={true}
                  required={true}
                  maxLength="50"
                  value={starCardData?.cLastName}
                  onBlur={(event) => onChangeInput(event)}
                />
              </Cell>
            </Row>
            <Row
              cols={2}
              className={cx(styles.modalGrid, styles.modalGridContact)}
            >
              <Cell>
                <label name="phoneNumber">
                <span 
                  className={cx(styles.required)}
                > 
                  <RCL searchKey="phone-number" />
                </span>  
                </label>
                <input
                  type="text"
                  id="phoneNumber"
                  value={phoneNumber}
                  required={true}
                  maxLength="10"
                  onChange={(event) => onChangeInput(event)}
                  onBlur={(event) => onChangeInput(event)}
                />
                {(isValidPhone !== null || submitting) && !isValidPhone ? (
                  <span className={cx(styles.error)}>
                    {dictionary["ERR_InvalidPhone"]}
                  </span>
                ) : null}
              </Cell>
              <Cell>
                <label name="fax">
                  <RCL searchKey="fax" />
                  <span>(optional)</span>
                </label>
                <input
                  type="text"
                  id="fax"
                  value={fax}
                  maxLength="16"
                  onChange={(event) => onChangeInput(event)}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onBlur={(event) => onChangeInput(event)}
                />
                {(isValidPhone !== null || submitting) && !isValidPhone ? (
                  <span className={cx(styles.errorEmpty)}></span>
                ) : null}
              </Cell>
            </Row>
            <Row className={styles.modalGrid}>
              <Cell>
                <label name="email">
                  <p>
                    <RCL searchKey="email" />
                    <span>
                      <RCL searchKey="emailToSignIn" />
                    </span>
                  </p>
                </label>
                <input
                  type="text"
                  id="email"
                  value={starCardData?.cLoginEmail}
                  readOnly={true}
                  required={true}
                  maxLength="50"
                  size="100"
                  onChange={(event) => onChangeInput(event)}
                  onBlur={(event) => onChangeInput(event)}
                />
              </Cell>
            </Row>
            <Row className={styles.modalGrid}>
              <Cell>
                <label name="address">
                <span 
                  className={cx(styles.required)}
                > 
                  <RCL searchKey="Address_STAR" />
                </span>  
                </label>
                <input
                  type="text"
                  id="address"
                  required={true}
                  maxLength="30"
                  size="40"
                  value={address}
                  onChange={(event) => onChangeInput(event)}
                  onBlur={(event) => onChangeInput(event)}
                  onFocus={handleStarAddress1Focus}
                />
                {(isValidAddress !== null || submitting) && !isValidAddress ? (
                  <span className={cx(styles.error)}>
                    {dictionary["ERR_InvalidAddress"]}
                  </span>
                ) : null}
                {showAddress1Example && (<div className={styles.addressExample}><RCL searchKey="please-follow-the-correct-mailing-address-format-as-per-displayed-example" /></div>)}
                                
              </Cell>
            </Row>
            <Row cols={3} className={styles.modalGrid}>
              <Cell>
                <label name="city">
                <span 
                  className={cx(styles.required)}
                > 
                  <RCL searchKey="city" />
                </span>  
                </label>
                <input
                  type="text"
                  id="city"
                  maxLength="50"
                  required={true}
                  value={city}
                  onChange={(event) => onChangeInput(event)}
                  onBlur={(event) => onChangeInput(event)}
                />
                {(isValidCity !== null || submitting) && !isValidCity ? (
                  <span className={cx(styles.error)}>
                    {dictionary["ERR_InvalidCity"]}
                  </span>
                ) : null}
              </Cell>
              <Cell>
                <label name="province">
                <span 
                  className={cx(styles.required)}
                > 
                  <RCL searchKey="province" />
                </span>  
                </label>
                <select
                  id="province"
                  required={true}
                  onChange={(event) => onChangeInput(event)}
                >
                  <option value="">
                    {RCL({
                      searchKey: "select",
                    })}
                  </option>
                  {provinceList &&
                    provinceList.map((prv) => (
                      <option key={prv.cProvince} value={prv.cProvince}>
                        {prv.cProvinceName}
                      </option>
                    ))}
                </select>
                {(isValidProvince !== null || submitting) &&
                !isValidProvince ? (
                  <span className={cx(styles.error)}>
                    {dictionary["ERR_InvalidProvince"]}
                  </span>
                ) : null}
              </Cell>
              <Cell>
                <label name="postalCode">
                <span 
                  className={cx(styles.required)}
                > 
                  <RCL searchKey="postalCode" />
                </span>  
                </label>
                <input
                  type="text"
                  id="postalCode"
                  required={true}
                  maxLength="10"
                  value={postalcode}
                  onChange={(event) => onChangeInput(event)}
                  onBlur={(event) => onChangeInput(event)}
                />
                {(isValidPostal !== null || submitting) && !isValidPostal ? (
                  <span className={cx(styles.error)}>
                    {dictionary["ERR_InvalidPostalCode"]}
                  </span>
                ) : null}
              </Cell>
            </Row>
            <Row cols={2} className={styles.modalGrid}>
              <Cell>
                <label name="dob">
                <span 
                  className={cx(styles.required)}
                > 
                 <RCL searchKey="birth-date" />
                </span>  
                </label>
                <input
                  type="text"
                  id="dateOfBirth"
                  placeholder="dd-MM-yyyy"
                  required={true}
                  value={dateOfBirth}
                  onChange={(event) => onChangeInput(event)}
                  onBlur={(event) => onChangeInput(event)}
                  onKeyDown={handleDateOfBirthKeyDown}
                  maxLength="10"
                />
                {(isValidDateOfBirth !== null || submitting) && !isValidDateOfBirth ? (
                  <span className={cx(styles.error)}>
                    {dictionary["Err_InvalidDateOfBirth"]}
                  </span>
                ) : null}
              </Cell>
              <Cell>
                <label name="shippingMethods">
                <span  className={cx(styles.required)}> 
                  <RCL searchKey="shipping-methods" />
                </span>  
                </label>
                <select
                  id="shippingMethod"
                  required={true}
                  defaultValue={1}
                  onChange={(event) => onChangeInput(event)}
                  disabled={true}
                >
                  <option value="">
                    {RCL({
                      searchKey: "select",
                    })}
                  </option>
                  {shippingMethods &&
                    shippingMethods.map((method) => (
                      <option key={method.shippingMethodCode} value={method.shippingMethodCode}>
                        {method.shippingMethodName}
                      </option>
                    ))}
                </select>
              </Cell>
            </Row>
            <div className={styles.modalConfirm}>             
              <ButtonComponent size="md" onClick={handleSubmit}>
                <RCL searchKey="register" />
              </ButtonComponent>              
              <p>
                <RCL searchKey="terms" />
              </p>             
            </div>
            </div>)}
          </form>
          {isSuccess && (
            <div>
             <ButtonComponent size="md" onClick={handleClose}>
                <RCL searchKey="modal-close" />
             </ButtonComponent>
            </div>)}          
        </Modal.Content>
      )}
    </Modal>
  );
};

export default StarCardModal;
export { StarCardModal };
